import { styled } from '@mui/material/styles';

export const ModalSubtitle = styled('div')({
  fontWeight: '500',
  fontSize: '1.35rem',
  color: '#b5b5c3 !important',
  marginBottom: '1.5rem',
});
